import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ClockThree = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM15 13H12C11.4 13 11 12.6 11 12V7C11 6.4 11.4 6 12 6C12.6 6 13 6.4 13 7V11H15C15.6 11 16 11.4 16 12C16 12.6 15.6 13 15 13Z"
      fill="currentColor"
    />
  </svg>
)

export default ClockThree
